import React from "react";
import {
  Badge,
  Box,
  Button,
  Flex,
  Image,
  Stack,
  Text,
  Skeleton,
} from "@chakra-ui/core";

import { Link, useHistory } from "react-router-dom";
import useAuth from "../../../context/AuthContext";
import { getUserProfile } from "../../../api/user.service";

export const MentorHomePage = () => {
  const history = useHistory();
  const [profile, setUserProfile] = React.useState();

  const {
    state: { user },
  } = useAuth();

  React.useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const { data } = await getUserProfile();
        setUserProfile(data.mentor);
      } catch (error) {
        console.log("err", error);
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <>
      <Box h='100vh' p={["10", "0"]}>
        {profile?.status === "accepted" && (
          <Stack
            w='100%'
            mx='auto'
            justifySelf='center'
            alignSelf='center'
            justify='center'
            align='center'
            h='90vh'
          >
            <Box w='100px' alignSelf='center' mb='6'>
              <Image
                src={require("../../../assets/icons/checked-user.png")}
                alt='Account Locked'
                w='100%'
              />
            </Box>

            <Text
              textAlign='center'
              fontSize={["xl", "2xl"]}
              fontWeight='700'
              my='6'
            >
              You have been accepted as a GrEEn Mentor
            </Text>
          </Stack>
        )}

        {profile?.status === "pending" && (
          <Stack
            w='100%'
            mx='auto'
            justifySelf='center'
            alignSelf='center'
            justify='center'
            align='center'
            h='90vh'
          >
            <Box w='100px' alignSelf='center'>
              <Image
                src={require("../../../assets/icons/user-pending.png")}
                alt='Account Locked'
                w='100%'
              />
            </Box>
            <Text>Account Pending</Text>
            <Text
              textAlign='center'
              fontSize={["xl", "2xl"]}
              fontWeight='700'
              mb='4'
            >
              Your application is under review, kindly check back later
            </Text>
            <Link to='/dashboard/me'>
              <Button mt='4'>View Profile</Button>
            </Link>
          </Stack>
        )}
      </Box>
    </>
  );
};
